import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import firebase from 'firebase'
import router from '../components/router'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        privateKey: localStorage.getItem('private_key') || ''
    },
    mutations: {
        SET_PRIVATE_KEY(state, key) {
            state.privateKey = key
        },
        CLEAR_PRIVATE_KEY(state) {
            state.privateKey = ''
        }
    },
    actions: {
        async getPrivateKey({ commit }) {
            try {
                const res = await axios.post(`${process.env.VUE_APP_karyawan}admin/auth/generate-api-key`, 
                    { app_name: 'amigoWebApiKey' },
                    {
                        headers: {
                            'X-Custom-User-Agent': process.env.VUE_APP_userAgent + navigator.userAgent
                        }
                    }
                )

                const apiKey = res.data?.data?.api_key
                if (!apiKey) throw new Error('API tidak mengembalikan api_key')

                commit('SET_PRIVATE_KEY', apiKey)
                localStorage.setItem('private_key', apiKey)
                return apiKey

            } catch (error) {
                throw error.response
            }
        },

        async ensurePrivateKey({ state, dispatch }) {
            if (!state.privateKey || !localStorage.getItem('private_key')) {
                await dispatch('getPrivateKey')
            }
        },

        clearPrivateKey({ commit }) {
            commit('CLEAR_PRIVATE_KEY')
            localStorage.removeItem('private_key')
        },
        
        async logout() {
            try {
                await firebase.auth().signOut()
            } catch (error) {
                console.error('Logout failed:', error)
            } finally {
                this.$toast.open({
                    message: 'Token expired !',
                    type: 'error',
                    position: 'top'
                })
                router.push({ name: 'Login' })
            }
        }
    }
})